'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sessionStorage = require('./util/sessionStorage');

var _actions = require('./actions');

var _openIdConnect = require('./openIdConnect');

var authMiddleware = function authMiddleware(_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;

  return function (next) {
    return function (action) {
      // When getting an async action (API call)
      // Ensure that access token is still valid and not expired
      if (typeof action === 'function' && getState().auth && getState().auth.clients && Object.keys(getState().auth.clients).length > 0) {
        // Check if any of the stored tokens is expired
        var tokenRefreshPromises = [];
        Object.keys(getState().auth.clients).forEach(function (clientId) {
          var client = getState().auth.clients[clientId];
          if (client.token && !(0, _openIdConnect.isTokenStillValid)(client.token, 300, false, client.iamConfig.expiryInMilliseconds)) {
            if (client.refreshTokenPromise) {
              tokenRefreshPromises.push(client.refreshTokenPromise);
            } else {
              var tokenRefresh = (0, _actions.refreshExpiredToken)(client.iamConfig, dispatch);
              if (typeof tokenRefresh.then === 'function') {
                tokenRefreshPromises.push(tokenRefresh);
              }
            }
          }
        });

        if (tokenRefreshPromises.length > 0) {
          return Promise.all(tokenRefreshPromises).then(function () {
            return next(action);
          });
        }

        return next(action);
      }

      switch (action.type) {
        case _actions.LOGIN_SUCCESS:
        case _actions.REFRESHING_TOKEN_SUCCESS:
          (0, _sessionStorage.setToken)(action.clientId, action.token);
          (0, _sessionStorage.setToken)(action.clientId + '_idToken', JSON.stringify(action.idToken));
          break;
        case _actions.LOGIN_FAILURE:
        case _actions.REFRESHING_TOKEN_FAILURE:
        case _actions.LOGOUT_SUCCESS:
        case _actions.LOGOUT_FAILURE:
          (0, _sessionStorage.removeToken)(action.clientId);
          (0, _sessionStorage.removeToken)(action.clientId + '_idToken');
          break;
        default:
          break;
      }

      return next(action);
    };
  };
};

exports.default = authMiddleware;